import React, { useEffect, useRef, useState } from 'react';
import { useParams, useHistory} from 'react-router-dom';
import { Button, Col, Container, Form, FormFeedback, Input, Label, Row } from 'reactstrap';
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from 'axios';
import ConfigData from '../config.json';
import GridRoomType from '../components/rooms-type/grid_room_type';
import Swal from 'sweetalert2';


const EventDetail = () => {
    const { id } = useParams();
    const history = useHistory();
    const [selectRoomTypeId, setSelectRoomTypeId] = useState(0);
    const [cbIsAllDay, setCbIsAllDay] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [isCanSave, setIsCanSave] = useState(true);
    const [dataRoomType, setDataRoomType] = useState([]);
    const [objEventDate, setObjEventData] = useState({
        id: 0,
        id_room_type: 0,
        reserve_by_id_employee_general: 0,
        reserve_by_employee_id: "",
        reserve_start_date: "",
        reserve_start_time: "",
        reserve_end_date: "",
        reserve_end_time: "",
        reserve_all_day: "",
        event_name: "",
        event_description: "",
        room_name: ""
    });

    useEffect(() => {
        let eventId = 0;
        try{
            let paramDecode = atob(id);
            let arrParam = paramDecode.split(";")
            if(arrParam.length > 0){
                eventId = arrParam[0];
                let dateStr = (arrParam[1] !== "" && arrParam[1] !== null && arrParam[1] !== undefined) ? arrParam[1] : "";
                let timeStr = (arrParam[2] !== "" && arrParam[2] !== null && arrParam[2] !== undefined) ? arrParam[2] : "";
                if(eventId.toString() === "0"){
                    setObjEventData({
                        id: 0,
                        id_room_type: 0,
                        reserve_by_id_employee_general: 0,
                        reserve_by_employee_id: "",
                        reserve_start_date: dateStr,
                        reserve_start_time: timeStr,
                        reserve_end_date: "",
                        reserve_end_time: "",
                        reserve_all_day: "",
                        event_name: "",
                        event_description: "",
                        room_name: ""
                    });
                }
            }

        }catch (error){
            eventId = 0;
        }
        LoadEventDetail(eventId);
        LoadRoomType();
    }, [id]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: objEventDate.id || 0,
            id_room_type: objEventDate.id_room_type || 0,
            reserve_by_id_employee_general: objEventDate.reserve_by_id_employee_general || 0,
            reserve_by_employee_id: objEventDate.reserve_by_employee_id || "",
            reserve_start_date: objEventDate.reserve_start_date || "",
            reserve_start_time: objEventDate.reserve_start_time || "", 
            reserve_end_date: objEventDate.reserve_end_date || "",
            reserve_end_time: objEventDate.reserve_end_time || "",
            reserve_all_day: objEventDate.reserve_all_day ||  "", 
            event_name: objEventDate.event_name || "", 
            event_description: objEventDate.event_description || "",
            room_name: objEventDate.room_name || "",
        },
        validationSchema: Yup.object({
            event_name: Yup.string().required("Please enter a title"),
            reserve_start_date: Yup.string().required("Please enter a date"),
            reserve_start_time: Yup.string().required("Please enter a start time"),
            reserve_end_time: Yup.string().required("Please enter a end time"),
            room_name: Yup.string().required("Please select a room"),
            // phone_number: Yup.string().required("Please enter a Contact"),
        }),
        onSubmit: (values) => {
            values.reserve_all_day = (values.reserve_all_day === "1") ? values.reserve_all_day : "0";
            values.reserve_end_date = values.reserve_start_date;
            values.reserve_by_id_employee_general = sessionStorage.getItem("uid");
            values.reserve_by_employee_id = sessionStorage.getItem("ueid");
            if(values.id > 0){
                UpdateEvent(values);
            }else{
                AddEvent(values);
            }
        }
    });

    const OnClickDelete = () => {
        Swal.fire({
            title: 'Delete Booking',
            text: 'Do you want to delete this booking ?',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            confirmButtonColor: '#9B8F70',
        }).then((result) => {
            if(result.isConfirmed){
                DeleteEvent(objEventDate.id);
            }
        });
    };

    const OnClickBack = () => {
        history.push("/");
    };

    const OnClickSelectRoom = (data) => {
        setSelectRoomTypeId(data.id);
        validation.setFieldValue("id_room_type", data.id);
        validation.setFieldValue("room_name", data.name);
    };

    const LoadEventDetail = (eventId) => {
        let url = ConfigData.API_URL + "event-reserve-room/" + eventId;
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingunicorn");
        axios.get(url, { headers: { 
            'Authorization' : token,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setObjEventData(respData.data[0]);
                setSelectRoomTypeId((respData.data[0].id_room_type > 0) ? respData.data[0].id_room_type : 0);
                setCbIsAllDay((respData.data[0].reserve_all_day === "1") ? true : false);
                setIsUpdate(true);
                const userId = (sessionStorage.getItem("uid") !== "" && sessionStorage.getItem("uid") != null && sessionStorage.getItem("uid") !== undefined) ? sessionStorage.getItem("uid") : 0;
                setIsCanSave((userId.toString() === respData.data[0].reserve_by_id_employee_general.toString()) ? true : false);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    const LoadRoomType = () => {
        let url = ConfigData.API_URL + "room-type/?status=1";
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingunicorn");
        axios.get(url, { headers: { 
            'Authorization' : token,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                setDataRoomType(respData.data);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    const AddEvent = (data) => {
        let url = ConfigData.API_URL + "event-reserve-room/";
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingunicorn");
        let userId = sessionStorage.getItem("uid");
        axios.post(url, data, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                Swal.fire({
                    icon: 'success',
                    title: 'Booking completed!',
                    text: 'Your booking was successful.',
                    confirmButtonColor: '#9B8F70',
                });
                history.push("/");
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Booking failed!',
                    text: respData.error,
                    confirmButtonColor: '#9B8F70',
                });
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to add the booking.',
                confirmButtonColor: '#9B8F70',
            });
        });
    };

    const UpdateEvent = (data) => {
        let url = ConfigData.API_URL + "event-reserve-room/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingunicorn");
        let userId = sessionStorage.getItem("uid");
        axios.put(url, data, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                Swal.fire({
                    icon: 'success',
                    title: 'Changed successfully!',
                    text: 'Your data has been successfully updated.',
                    confirmButtonColor: '#9B8F70',
                });
                history.push("/");
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Changed failed!',
                    text: respData.error,
                    confirmButtonColor: '#9B8F70',
                });
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to change the booking.',
                confirmButtonColor: '#9B8F70',
            });
        });
    };

    const DeleteEvent = (id) => {
        let url = ConfigData.API_URL + "event-reserve-room/" + id;
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingunicorn");
        let userId = sessionStorage.getItem("uid");
        axios.delete(url, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                Swal.fire({
                    icon: 'success',
                    title: 'Booking deleted !',
                    text: 'Your booking has been deleted.',
                    confirmButtonColor: '#9B8F70',
                });
                history.push("/");
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete the booking.',
                confirmButtonColor: '#9B8F70',
            });
        });
    };
    const [isDatePickerOpen, setDatePickerOpen] = useState(false);
    const handleButtonClick = () => {
        setDatePickerOpen(true);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form className="needs-validation event-detail"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col lg={12}>
                                <h5 className="ed-title-header">Create New Booking</h5>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <div className="float-end">
                                    <Button type="submit" className="me-1 ed-button-save" style={{display: (isCanSave === false) ? "none" : "inline-block"}}>
                                        {(isUpdate === false) ? "Book" : "Save"}
                                    </Button>
                                    <Button type="button" onClick={OnClickDelete} className="mx-2 ed-button-delete" style={{display: (isCanSave === false || isUpdate === false) ? "none" : "inline-block"}} >
                                        Delete
                                    </Button>
                                    <Button type="button" onClick={OnClickBack} className="ms-1 btn-icon ed-button-back">
                                        <i className="ri-close-line" />
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={5}>
                                <Row className="ed-mb-28">
                                    <Col lg={12}>
                                        <Input id="txtName"
                                            name="event_name"
                                            placeholder="Title"
                                            className="from-control ed-input-name"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.event_name || ""}
                                            invalid={ validation.touched.event_name && validation.errors.event_name ? true : false }    
                                        />
                                        { validation.touched.event_name && validation.errors.event_name ? 
                                            ( <FormFeedback type="invalid">{validation.errors.event_name}</FormFeedback> ) : false 
                                        }
                                    </Col>
                                </Row>
                                <Row className="ed-mb-18">
                                    <Col lg={12}>
                                        <div className="form-icon">
                                            <Input id="txtDescription" 
                                                name="event_description"
                                                placeholder="Description"
                                                className="form-control form-control-icon ed-input-description"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.event_description || ""}
                                            />
                                            <i className="ri-bar-chart-horizontal-fill ed-color-gold"></i> 
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="ed-mb-18">
                                    <Col lg={12}>
                                        <div className="form-icon">
                                            <Input id="txtStartDate"
                                                name="reserve_start_date"
                                                placeholder="Date"
                                                type="date"
                                                className="from-control ed-input-date"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.reserve_start_date || ""}
                                                invalid={ validation.touched.reserve_start_date && validation.errors.reserve_start_date ? true : false }
                                            />
                                            <i className="ri-calendar-todo-fill ed-color-gold"></i>
                                        </div>
                                        { validation.touched.reserve_start_date && validation.errors.reserve_start_date ? 
                                            ( <div className="error-msg">{validation.errors.reserve_start_date}</div> ) : false 
                                        }
                                    </Col>
                                </Row>
                                <Row className="ed-mb-18">
                                    <Col lg={12}>
                                        <div className="form-check form-switch form-switch-md form-switch-gold">
                                            <Input id="cbAllDay"
                                                name="reserve_all_day"
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={cbIsAllDay}
                                                onChange={(e) => {
                                                    setCbIsAllDay(!cbIsAllDay);
                                                    validation.setFieldValue("reserve_all_day", (!cbIsAllDay === true) ? "1" : "0");
                                                    validation.setFieldValue("reserve_start_time", (!cbIsAllDay === true) ? "00:00" : "");
                                                    validation.setFieldValue("reserve_end_time", (!cbIsAllDay === true) ? "23:59" : "");
                                                }}
                                                // onChange={validation.handleChange}
                                                // onBlur={validation.handleBlur}
                                                // value={validation.values.reserve_all_day || ""}
                                            />
                                            <Label className="form-check-label eb-cb-allday-label" for="cbAllDay">All Day</Label>
                                        </div>
                                        

                                    </Col>
                                </Row>
                                <Row className="ed-mb-18" style={{display: (cbIsAllDay === true) ? "none" : "flex"}}>
                                    <Col xs={12} sm={12} md={5} lg={5}>
                                        <div className="form-icon">
                                            <Input id="txtStartTime" 
                                                name="reserve_start_time"
                                                placeholder="Start time"
                                                type="time"
                                                className="from-control ed-time-input"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.reserve_start_time || ""}
                                                invalid={ validation.touched.reserve_start_time && validation.errors.reserve_start_time ? true : false }                                 
                                            />
                                            <i className="ri-time-fill ed-color-gold"></i> 
                                        </div>
                                        { validation.touched.reserve_start_time && validation.errors.reserve_start_time ? 
                                            ( <div className="error-msg">{validation.errors.reserve_start_time}</div> ) : false 
                                        }
                                    </Col>
                                    <Col xs={12} sm={12} md={2} lg={2} className="clearfix">
                                        <div className="ed-time-div-icon">
                                            <i className="ri-arrow-right-line ed-color-gold"></i> 
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={5} lg={5}>
                                        <div className="form-icon">
                                            <Input id="txtEndTime" 
                                                name="reserve_end_time"
                                                placeholder="End time"
                                                type="time"
                                                className="from-control ed-time-input"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.reserve_end_time || ""}
                                                invalid={ validation.touched.reserve_end_time && validation.errors.reserve_end_time ? true : false }                                 
                                            />
                                            <i className="ri-time-fill ed-color-gold"></i>
                                        </div>
                                        { validation.touched.reserve_end_time && validation.errors.reserve_end_time ? 
                                            ( <div className="error-msg">{validation.errors.reserve_end_time}</div> ) : false 
                                        }
                                    </Col>
                                </Row>
                                <Row className="ed-mb-18">
                                    <Col lg={12}>
                                        <div className="form-icon">
                                            <Input id="txtLocation" 
                                                name="room_name"
                                                placeholder="Room"
                                                className="from-control form-control-icon ed-input-location"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.room_name || ""}
                                                invalid={ validation.touched.room_name && validation.errors.room_name ? true : false }
                                                disabled  
                                            />
                                            <i className="ri-map-pin-2-fill ed-color-gold"></i> 
                                        </div>
                                        { validation.touched.room_name && validation.errors.room_name ? 
                                            ( <div className="error-msg">{validation.errors.room_name}</div> ) : false 
                                        }
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={1}>
                                <p> </p>
                            </Col>
                            <Col lg={6}>
                                <Row>
                                    <Col lg={12}>
                                        <p className="ed-title-rooms">What kind of room</p>
                                        <p className="ed-title-rooms">would you like?</p>
                                        <GridRoomType data={dataRoomType} roomTypeId={selectRoomTypeId} onClickSelect={OnClickSelectRoom} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        </React.Fragment>
    )
};

export default EventDetail;